/* ZSportsTech — cart-addons.js
   The "Goes with your bat" rail inside the slide-out cart drawer. Reads the
   two compact maps emitted by snippets/cart-drawer.liquid (window.SC_ADDONS_FOR,
   window.SC_ADDON_CATALOG) — no fetch of its own. cart.js calls
   window.SCCartAddons.render(cart) at the end of every render(), so the rail
   always stays in sync with the drawer's line items.

   Public API: window.SCCartAddons.render(cart)
   ─────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }

  /* Knocking-in + tape are offered FREE per bat directly under the bat's own
     line (see cart.js's "Free with your bat" block), and Bat Wax + Bat Grips
     are offered at 10% off in cart.js's "Get these at an additional discount
     with your bat" block, both once a qualifying bat is in the cart — don't
     also pitch any of the four here as a plain paid add-on. */
  var BAT_PRODUCT_TYPES = ['Cricket Bat', 'Junior Cricket Bat'];
  var FREE_WITH_BAT_HANDLES = ['knocking-in-on-your-new-bat', 'tape'];
  var DISCOUNTED_WITH_BAT_HANDLES = ['bat-wax', 'bat-grips'];

  function formatMoney(rupees) {
    var cents = Math.round(rupees * 100);
    if (window.SCCart && typeof window.SCCart.format === 'function') return window.SCCart.format(cents);
    return '₹' + rupees;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Cart items that already have an add(id, qty) request in flight, keyed by
     handle, so a double-tap on the same card before the drawer re-renders
     can't add twice. */
  var pending = {};

  /* Adds one unit of `addon` (an { id, count } descriptor — either an
     SC_ADDON_CATALOG entry or an SC_BAT_OFFERS one, same shape) for product
     `handle`. Single-variant products add straight to cart; multi-variant
     ones (Bat Grips, Bat Covers) open the shared variant picker first. Shared
     so cart.js's bat-offers cards and this rail's own cards can't drift on
     how "+ Add" behaves. */
  function addProductByHandle(handle, addon, btn) {
    if (!addon || pending[handle]) return;

    if (addon.count === 1 && addon.id) {
      pending[handle] = true;
      btn.disabled = true;
      window.SCCart.add(addon.id, 1).then(function () {
        pending[handle] = false;
        btn.disabled = false;
      });
      return;
    }

    if (!window.SCVariantPicker) {
      console.error('[SCCartAddons] window.SCVariantPicker is missing; cannot pick a variant for "' + handle + '".');
      return;
    }

    pending[handle] = true;
    btn.disabled = true;
    window.SCVariantPicker.open(handle, function (variantId) {
      if (!variantId) {
        pending[handle] = false;
        btn.disabled = false;
        return;
      }
      window.SCCart.add(variantId, 1).then(function () {
        pending[handle] = false;
        btn.disabled = false;
      });
    });
  }

  function handleAdd(handle, btn) {
    addProductByHandle(handle, (window.SC_ADDON_CATALOG || {})[handle], btn);
  }

  function cardHtml(handle, addon) {
    var img = addon.img
      ? '<img class="sc-cart__addon-img" src="' + escapeHtml(addon.img) + '" alt="" loading="lazy">'
      : '<span class="sc-cart__addon-img sc-cart__addon-img--ph" aria-hidden="true">Z</span>';
    var priceText = addon.count > 1
      ? 'from ' + formatMoney(addon.priceMin)
      : formatMoney(addon.price);
    var reason = addon.reason
      ? '<div class="sc-cart__addon-reason">' + escapeHtml(addon.reason) + '</div>'
      : '';
    return '<div class="sc-cart__addon" data-addon-handle="' + escapeHtml(handle) + '">' +
      img +
      '<div class="sc-cart__addon-meta">' +
        '<div class="sc-cart__addon-title">' + escapeHtml(addon.title) + '</div>' +
        reason +
        '<div class="sc-cart__addon-price">' + priceText + '</div>' +
      '</div>' +
      '<button type="button" class="sc-cart__addon-add" data-addon-add>+ Add</button>' +
    '</div>';
  }

  function render(cart) {
    var rail = $('sc-cart-addons');
    if (!rail) return;

    var FOR = window.SC_ADDONS_FOR || {};
    var CATALOG = window.SC_ADDON_CATALOG || {};
    var items = (cart && cart.items) || [];

    var inCart = {};
    items.forEach(function (it) { inCart[it.handle] = true; });

    var handles = [];
    var seen = {};
    items.forEach(function (it) {
      var addons = FOR[it.handle];
      if (!addons) return;
      addons.forEach(function (h) {
        if (seen[h]) return;
        seen[h] = true;
        handles.push(h);
      });
    });

    var hasBat = items.some(function (it) { return BAT_PRODUCT_TYPES.indexOf(it.product_type) !== -1; });
    handles = handles.filter(function (h) {
      if (hasBat && (FREE_WITH_BAT_HANDLES.indexOf(h) !== -1 || DISCOUNTED_WITH_BAT_HANDLES.indexOf(h) !== -1)) return false;
      return !inCart[h] && CATALOG[h];
    });

    if (!handles.length) {
      rail.hidden = true;
      rail.innerHTML = '';
      return;
    }

    var show = handles.slice(0, 4);
    rail.innerHTML = '<div class="sc-cart__addons-title">Goes with your bat</div>' +
      show.map(function (h) { return cardHtml(h, CATALOG[h]); }).join('');
    rail.hidden = false;

    Array.prototype.slice.call(rail.querySelectorAll('[data-addon-add]')).forEach(function (btn) {
      var card = btn.closest('.sc-cart__addon');
      var handle = card.getAttribute('data-addon-handle');
      btn.addEventListener('click', function () { handleAdd(handle, btn); });
    });
  }

  window.SCCartAddons = { render: render, addProduct: addProductByHandle };
}());
